module.exports = __webpack_public_path__ + "static/media/discord.80cc8a0b.svg";